<div class="tw-flex tw-flex-col tw-border-gray-200 tw-rounded-lg tw-gap-2 lg:tw-gap-[12.5px]">
  <div class="tw-flex tw-flex-col">
  <app-banner-upload-field
            [organizationId]="event()?.workspace_id"
            [eventId]="event()?.id"
            [originalImageUrl]="event()?.original_image ?? null"
            label="Add event banner"
            hint="Attach photos in PNG, JPG, JPEG, WEBP, BMP. (Aspect ratio: 12:5)"
            [showIcon]="true"
            [control]="coverPageControl()"
            [isLoading]="isLoading()"
            [timelineLayout]="timelineBannerLayout()"
            [readonly]="isInteractionReadonly()"
            (valueChanged)="onBannerChanged($event)"
    ></app-banner-upload-field>
    <div class="tw-flex tw-flex-col tw-px-3 tw-py-2 lg:tw-pt-4 lg:tw-pb-3 tw-gap-1 lg:tw-gap-3 tw-border-b tw-border-r tw-border-l tw-rounded-b-lg tw-bg-white">
      <div class="tw-flex tw-flex-row tw-items-center tw-justify-between tw-gap-[14px] lg:tw-hidden">
        <h1
          class="tw-text-gray-900 tw-font-inter tw-text-base tw-font-extrabold"
          [ngClass]="{ '!tw-cursor-not-allowed': isInteractionReadonly() }"
          (click)="navigateToEdit()"
        >{{ event().name }}</h1>
        @if (visibleEventMenuOptions().length) {
          <app-dropdown
            [dropdownOptions]="visibleEventMenuOptions()"
            [widthInPX]="'auto'"
            [maxWidthInPX]="'250px'"
            [heightInPX]="0"
            [dropdownListXPosition]="'left'"
            [dropdownListYPosition]="'bottom'"
            (optionClicked)="onEventMenuOption($event)"
          >
            <button
              type="button"
              class="tw-border tw-border-gray-200 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-p-1 tw-cursor-pointer focus:tw-bg-gray-100 dropdownButton"
              aria-label="More options"
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path
                  d="M12.6 8.39961C13.3732 8.39961 14 7.77281 14 6.99961C14 6.22641 13.3732 5.59961 12.6 5.59961C11.8268 5.59961 11.2 6.22641 11.2 6.99961C11.2 7.77281 11.8268 8.39961 12.6 8.39961Z"
                  fill="currentColor"
                />
                <path
                  d="M7 8.39961C7.7732 8.39961 8.4 7.77281 8.4 6.99961C8.4 6.22641 7.7732 5.59961 7 5.59961C6.2268 5.59961 5.6 6.22641 5.6 6.99961C5.6 7.77281 6.2268 8.39961 7 8.39961Z"
                  fill="currentColor"
                />
                <path
                  d="M1.4 8.39961C2.1732 8.39961 2.8 7.77281 2.8 6.99961C2.8 6.22641 2.1732 5.59961 1.4 5.59961C0.626801 5.59961 0 6.22641 0 6.99961C0 7.77281 0.626801 8.39961 1.4 8.39961Z"
                  fill="currentColor"
                />
              </svg>
            </button>
          </app-dropdown>
        }
      </div>
      <div class="tw-flex tw-gap-2 tw-items-start lg:tw-items-center">
        <span class="tw-w-[14px] tw-h-[14px] lg:tw-w-[18px] lg:tw-h-[18px]">

          <svg class="tw-block lg:tw-hidden tw-mt-0.5 lg:tw-mt-0" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.99848 2.66919e-06C5.93496 -0.000994465 4.89143 0.277402 3.98095 0.805031C3.07047 1.33266 2.32776 2.0894 1.83327 2.99327C1.33879 3.89715 1.11139 4.91368 1.17571 5.93275C1.24003 6.95181 1.59362 7.93455 2.19817 8.7745C2.22237 8.82014 2.25171 8.8631 2.28568 8.9026L2.37318 9.0048C2.45485 9.1063 2.53871 9.2043 2.6109 9.2848L6.43554 13.7466C6.50411 13.8261 6.59014 13.89 6.68746 13.9338C6.78478 13.9776 6.89099 14.0002 6.99848 14C7.10626 14 7.21272 13.9772 7.31019 13.933C7.40765 13.8888 7.4937 13.8244 7.56215 13.7445L11.2752 9.401C11.4256 9.24576 11.5664 9.08214 11.6967 8.911L11.7893 8.8025C11.8246 8.76137 11.8545 8.71623 11.8783 8.6681C12.4545 7.82344 12.7822 6.84494 12.8265 5.83615C12.8709 4.82737 12.6303 3.82584 12.1302 2.93757C11.6302 2.0493 10.8892 1.30734 9.98586 0.790224C9.08249 0.273104 8.05027 6.34605e-05 6.99848 2.66919e-06ZM6.99848 3.5C7.43114 3.5 7.85409 3.62316 8.21384 3.85392C8.57359 4.08467 8.85398 4.41264 9.01955 4.79637C9.18512 5.18009 9.22845 5.60233 9.14404 6.00969C9.05963 6.41705 8.85128 6.79123 8.54534 7.08493C8.2394 7.37862 7.84961 7.57862 7.42526 7.65965C7.0009 7.74068 6.56105 7.69909 6.16132 7.54015C5.76159 7.3812 5.41994 7.11204 5.17956 6.7667C4.93919 6.42136 4.81089 6.01534 4.81089 5.6C4.81089 5.04305 5.04136 4.5089 5.45162 4.11508C5.86187 3.72125 6.41829 3.5 6.99848 3.5Z" fill="#6B7280"/>
          </svg>
          <svg class="tw-hidden lg:tw-block" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_43108_263512)">
            <path d="M8.99818 3.43181e-06C7.6308 -0.0012786 6.28912 0.35666 5.11851 1.03504C3.94789 1.71342 2.99297 2.68638 2.3572 3.8485C1.72144 5.01062 1.42907 6.31759 1.51177 7.62782C1.59446 8.93804 2.04908 10.2016 2.82636 11.2815C2.85747 11.3402 2.8952 11.3954 2.93887 11.4462L3.05137 11.5776C3.15637 11.7081 3.26419 11.8341 3.35701 11.9376L8.2744 17.6742C8.36257 17.7764 8.47318 17.8585 8.59831 17.9149C8.72343 17.9712 8.85998 18.0003 8.99818 18C9.13676 18.0001 9.27364 17.9706 9.39895 17.9138C9.52426 17.857 9.6349 17.7743 9.7229 17.6715L14.4969 12.087C14.6902 11.8874 14.8712 11.677 15.0387 11.457L15.1578 11.3175C15.2032 11.2646 15.2416 11.2066 15.2722 11.1447C16.0131 10.0587 16.4343 8.80063 16.4914 7.50362C16.5484 6.20662 16.2391 4.91894 15.5961 3.77688C14.9532 2.63482 14.0006 1.68087 12.8391 1.016C11.6776 0.351133 10.3505 8.15921e-05 8.99818 3.43181e-06ZM8.99818 4.5C9.55447 4.5 10.0983 4.65835 10.5608 4.95503C11.0233 5.25171 11.3838 5.6734 11.5967 6.16676C11.8096 6.66012 11.8653 7.203 11.7568 7.72675C11.6482 8.25049 11.3804 8.73159 10.987 9.10919C10.5937 9.48679 10.0925 9.74394 9.5469 9.84812C9.0013 9.9523 8.43578 9.89883 7.92184 9.69448C7.4079 9.49012 6.96863 9.14405 6.65958 8.70004C6.35052 8.25603 6.18556 7.73401 6.18556 7.2C6.18556 6.48392 6.48189 5.79716 7.00936 5.29081C7.53683 4.78447 8.25223 4.5 8.99818 4.5Z" fill="#6B7280"/>
            </g>
            <defs>
            <clipPath id="clip0_43108_263512">
            <rect width="18" height="18" fill="white"/>
            </clipPath>
            </defs>
          </svg>          
        </span>
        <div class="tw-flex tw-max-w-full tw-pr-[19px] lg:tw-pr-7">
          <p
            #locationTruncation="appTruncationDetector"
            appTruncationDetector
            class="tw-text-gray-900 tw-text-sm tw-font-inter tw-font-medium tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis"
            [ngxTippy]="locationTruncation.isTruncated() ? locationLabel() : ''"
          >
            {{ locationLabel() }}
          </p>
          @if (timezoneLabel()) {
            <p class="tw-text-gray-900 tw-text-sm tw-font-inter tw-font-medium">{{ timezoneLabel() }}</p>
          }
        </div>
      </div>
      <app-event-personas
        [event]="event()"
        [personas]="personas()"
        [personasTotal]="personasTotal()"
        [personasLoading]="personasLoading()"
        [isCreatingPersona]="createPersonaPending()"
        [createPersonaApiError]="createPersonaApiError()"
        [readonly]="isInteractionReadonly()"
        [canCreatePersona]="canCreatePersona()"
        [canViewPersonasList]="canViewPersonasList()"
        (createPersonaSubmitted)="onCreatePersonaSubmitted($event)"
        (personaNameUpdate)="onPersonaNameUpdate($event)"
        (personaLandingPageClick)="onPersonaLandingPageClick($event)"
        (personaViewRegistrantsClick)="onPersonaViewRegistrantsClick($event)"
        (personaCloned)="onPersonaCloned($event)"
        (personaArchiveClick)="onPersonaArchiveClick($event)"
        (legacyPersonaEditorClosed)="onLegacyPersonaEditorClosed($event)"
        (personasListingWizardClosed)="onPersonasListingWizardClosed($event)"
        class="tw-hidden lg:tw-block"
      ></app-event-personas>
      <app-event-tracking [event]="event()" [loadingCounts]="loadingCounts()" [readonly]="isInteractionReadonly()" [archived]="archived()" class="tw-hidden lg:tw-block"></app-event-tracking>
    </div>
  </div>
  <app-event-personas
    [event]="event()"
    [personas]="personas()"
    [personasTotal]="personasTotal()"
    [personasLoading]="personasLoading()"
    [personaPaginationEnabled]="true"
    [isCreatingPersona]="createPersonaPending()"
    [createPersonaApiError]="createPersonaApiError()"
    [readonly]="isInteractionReadonly()"
    [canCreatePersona]="canCreatePersona()"
    [canViewPersonasList]="canViewPersonasList()"
    (createPersonaSubmitted)="onCreatePersonaSubmitted($event)"
    (personaNameUpdate)="onPersonaNameUpdate($event)"
    (personaLandingPageClick)="onPersonaLandingPageClick($event)"
    (personaViewRegistrantsClick)="onPersonaViewRegistrantsClick($event)"
    (personaCloned)="onPersonaCloned($event)"
    (personaArchiveClick)="onPersonaArchiveClick($event)"
    (legacyPersonaEditorClosed)="onLegacyPersonaEditorClosed($event)"
    (personasListingWizardClosed)="onPersonasListingWizardClosed($event)"
    class="tw-block lg:tw-hidden"
  ></app-event-personas>
  <app-event-tracking [event]="event()" [loadingCounts]="loadingCounts()" [readonly]="isInteractionReadonly()" [archived]="archived()" class="tw-block lg:tw-hidden"></app-event-tracking>
</div>